document.addEventListener('DOMContentLoaded', () => {
  const quantity = document.getElementById('quantity');
  const coverageDisplay = document.getElementById('bmp-calculated-area');
  const coverageDisplay2 = document.getElementById('bmp-calculated-area2');
  const totalPriceElement = document.getElementById('getTotalprice');

  if (!quantity || !totalPriceElement) return;

  function getUnitPrice() {
    const raw = totalPriceElement.getAttribute('data-regular-price') || '0';
    return parseFloat(String(raw).replace(/[^0-9.]/g, '')) || 0;
  }

  function getCoveragePerBox() {
    if (!coverageDisplay) return 0;
    return (
      parseFloat(coverageDisplay.getAttribute('data-fixed-value')) ||
      parseFloat(coverageDisplay.getAttribute('value')) ||
      0
    );
  }

  function formatPrice(value) {
    return `$${parseFloat(value).toFixed(2)}`;
  }

  function updateDisplay() {
    let currentValue = quantity.value.trim();

    if (currentValue === '' || isNaN(currentValue) || currentValue < 1) {
      quantity.value = 1;
      currentValue = 1;
    }

    currentValue = parseInt(currentValue, 10);
    const coveragePerBox = getCoveragePerBox();
    const unitPrice = getUnitPrice();
    const finalCoverage = (coveragePerBox * currentValue).toFixed(2);
    const finalPrice = (unitPrice * currentValue).toFixed(2);

    if (coverageDisplay) coverageDisplay.value = finalCoverage;
    if (coverageDisplay2) coverageDisplay2.textContent = finalCoverage;
    totalPriceElement.textContent = formatPrice(finalPrice);
  }

  window.increaseValue = function increaseValue() {
    quantity.value = parseInt(quantity.value || 1, 10) + 1;
    updateDisplay();
  };

  window.decreaseValue = function decreaseValue() {
    const currentValue = parseInt(quantity.value || 1, 10);
    if (currentValue > 1) {
      quantity.value = currentValue - 1;
      updateDisplay();
    }
  };

  quantity.addEventListener('input', updateDisplay);

  const plusBtn = document.querySelector('.quantity-btn.plus');
  const minusBtn = document.querySelector('.quantity-btn.minus');
  if (plusBtn) plusBtn.addEventListener('click', window.increaseValue);
  if (minusBtn) minusBtn.addEventListener('click', window.decreaseValue);

  if (coverageDisplay) {
    let debounceTimeout;
    coverageDisplay.addEventListener('input', () => {
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(() => {
        const coveragePerBox = getCoveragePerBox();
        let coverageValue = parseFloat(coverageDisplay.value.trim());

        if (!coverageDisplay.value.trim() || isNaN(coverageValue) || coverageValue <= 0 || !coveragePerBox) {
          if (coverageDisplay2) coverageDisplay2.textContent = '0';
          quantity.value = '1';
          totalPriceElement.textContent = formatPrice(getUnitPrice());
          return;
        }

        const newQuantity = Math.max(1, Math.ceil(coverageValue / coveragePerBox));
        const adjustedCoverage = (newQuantity * coveragePerBox).toFixed(2);
        quantity.value = newQuantity;
        if (coverageDisplay2) coverageDisplay2.textContent = adjustedCoverage;
        totalPriceElement.textContent = formatPrice(getUnitPrice() * newQuantity);
      }, 300);
    });
  }

  updateDisplay();
});
